import { LuContainer } from "react-icons/lu";
import { Kandang, TabelProduksiTelur } from "@/pages/kandang";

export const farmRoutes = {
    title: "PETERNAKAN",
    type: "section",
    items: [
        {
            path: "/kandang",
            title: "Kandang",
            component: <Kandang />,
            icon: <LuContainer />,
            permission: "coop.view",
        },
        {
            path: "/barak/:barrackId/batch/:batchNumber/tabel-produksi-telur",
            title: "Produksi Telur",
            component: <TabelProduksiTelur />,
            type: "hidden",
            permission: "egg-production.view",
        },
    ],
};
